import {RoomSessionClientState} from '../../../../shared/scripts/RoomSessionClientState.ts'
import {UIRoomUserList} from '../../../../shared/scripts/ui_html/room/UIRoomUserList'
import {ViewPopupEditProfile, EditProfileTab} from '../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {UIMProfileUsernameController} from '../main_page/body/UIMProfileUsernameController'
import {ViewPopupEditBotProfile} from '../../../../shared/scripts/ui_popup/ViewPopupEditBotProfile'
import {socket} from '../../../../shared/scripts/EntryShared.ts'

export class UIMRoomUserListController extends UIRoomUserList {
    // eslint-disable-next-line class-methods-use-this
    protected openEditProfileForPlayer(player: RoomSessionClientState | undefined): void {
        if(player?.isBot) {
            new ViewPopupEditBotProfile({
                usernameController: UIMProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => {
                    if(player == undefined) return
                    socket.roomClient.selectColor(player.roomSessionId, color)
                },
                tab: EditProfileTab.Color,
                selectedColor: player?.selectedColor,
                username: player?.username,
            })
            return
        }

        new ViewPopupEditProfile({
            usernameController: UIMProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => {
                if(player == undefined) return
                socket.roomClient.selectColor(player.roomSessionId, color)
            },
            tab: EditProfileTab.Color,
            selectedColor: player?.selectedColor,
        })
    }
}
